import {Status} from "../enums/enums";

export const restaurantSchema = () => {
    return (
        {
            name: {
                type: 'text',
                label: 'Name',
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    if (value.trim() === '') return 'Name is required';
                    return null;
                },
            },
            image: {
                type: 'file',
                label: 'Image',
                columns: {md: 12, lg: 6},
            },
            foodLicense: {
                type: 'text',
                label: 'Food License',
                columns: {md: 12, lg: 4},
            },
            regId: {
                type: 'text',
                label: 'Reg Id',
                columns: {md: 12, lg: 4},
            },
            status: {
                type: 'select',
                label: 'Status',
                enums: true,
                options: Status,
                columns: {md: 12, lg: 4},
                validation: (value) => {
                    if (value === '') return 'Status is required';
                    return null;
                },
            },
            description: {
                type: 'textarea',
                label: 'Description',
            },
        }
    )
}

